import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function MatrimonialApprovals() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState({});

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/matrimonial/pending");
      setItems(data?.items || []);
    } catch {
      toast.error("Could not load pending profiles");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const act = async (profileId, action) => {
    setBusy((b) => ({ ...b, [profileId]: true }));
    try {
      await api.post(`/admin/matrimonial/${profileId}/${action}`);
      toast.success(action === "approve" ? "Approved" : "Rejected");
      setItems((xs) => xs.filter((x) => x.profile_id !== profileId));
    } catch {
      toast.error(`Could not ${action}`);
    } finally {
      setBusy((b) => ({ ...b, [profileId]: false }));
    }
  };

  if (loading) return <Card className="p-6 text-center text-sm text-muted-foreground" data-testid="admin-matri-loading">Loading…</Card>;
  if (items.length === 0) {
    return (
      <Card className="p-10 border-border/60 text-center" data-testid="admin-matri-empty">
        <p className="text-sm text-muted-foreground">No matrimonial applications pending review.</p>
      </Card>
    );
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="admin-matri-grid">
      {items.map((p) => (
        <Card key={p.profile_id} className="p-4 border-border/60 flex gap-3" data-testid={`admin-matri-card-${p.profile_id}`}>
          <div className="w-24 h-32 shrink-0 rounded-lg bg-muted overflow-hidden">
            {p.photo_url ? <img src={p.photo_url} alt="" className="w-full h-full object-cover" /> : null}
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-semibold text-sm truncate">{p.name} · {p.age} · {p.gender}</div>
            <div className="text-[11px] text-muted-foreground truncate">{p.city} · {p.gotra || "—"}</div>
            <div className="text-[11px] text-muted-foreground truncate">{[p.education, p.profession].filter(Boolean).join(" · ")}</div>
            <div className="text-[11px] text-muted-foreground truncate">{p.marital_status || "Never Married"} {p.kundali?.manglik ? "· Manglik" : ""}</div>
            {p.applied_at && <div className="text-[10px] text-muted-foreground mt-1">Applied {new Date(p.applied_at).toLocaleString()}</div>}
            <div className="flex items-center gap-2 mt-2">
              <Button
                size="sm"
                className="rounded-full bg-emerald-600 text-white h-7 text-xs"
                disabled={busy[p.profile_id]}
                onClick={() => act(p.profile_id, "approve")}
                data-testid={`admin-matri-approve-${p.profile_id}`}
              >
                Approve
              </Button>
              <Button
                size="sm"
                variant="outline"
                className="rounded-full h-7 text-xs"
                disabled={busy[p.profile_id]}
                onClick={() => act(p.profile_id, "reject")}
                data-testid={`admin-matri-reject-${p.profile_id}`}
              >
                Reject
              </Button>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
